var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostSearchHeader',{scopedSlots:_vm._u([{key:"header-title",fn:function(){return [_vm._v(" Coverage Guidelines ")]},proxy:true},{key:"header-description",fn:function(){return [_vm._v(" Evidence-based coverage guidelines developed by genetics specialists with clinical expertise and research experience. ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }